import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-basic-button_lock",
  "use": "icon-basic-button_lock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-basic-button_lock\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M7.18 8.7c.001-.294-.005-1.022 0-1.61.018-2.73 2.4-4.96 5.318-4.981 2.919-.021 5.27 2.175 5.25 4.906V8.7M12.5 14.196v3.925\" stroke-linecap=\"round\" /><rect x=\"3.75\" y=\"9.45\" width=\"17.5\" height=\"12.8\" rx=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol